import {CommonModule, registerLocaleData} from '@angular/common';
import {provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import en from '@angular/common/locales/en';
import ru from '@angular/common/locales/ru';
import {ErrorHandler, LOCALE_ID, NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {ServiceWorkerModule} from '@angular/service-worker';
import {NbAuthModule} from '@nebular/auth';
import {NbEvaIconsModule} from '@nebular/eva-icons';
import {
  NbAlertModule,
  NbButtonModule,
  NbCardModule,
  NbDatepickerModule,
  NbInputModule,
  NbLayoutModule,
  NbThemeModule
} from '@nebular/theme';
import {LOADING_BAR_CONFIG, LoadingBarModule} from '@ngx-loading-bar/core';
import {LoadingBarHttpClientModule} from '@ngx-loading-bar/http-client';
import {LoadingBarRouterModule} from '@ngx-loading-bar/router';
import {TuiRoot} from '@taiga-ui/core';
import {provideEventPlugins} from '@taiga-ui/event-plugins';
import {TUI_LANGUAGE} from '@taiga-ui/i18n';
import {AuthModule} from 'compob2b-auth';
import {Environment, SharedModule} from 'compob2b-libs';
import {FileUploadModule} from 'ng2-file-upload';
import {of} from 'rxjs';
import {CompoErrorHandler} from '../../../compob2b-libs/src/lib/handlers/compo.error.handler';
import {environment} from '../environments/environment';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {CabinetModule} from './cabinet/cabinet.module';
import {DamModule} from './cabinet/dam/dam.module';
import {DamFilesModule} from './cabinet/dam/files/dam-files.module';
import {AdminSignInComponent} from './sign-in/admin-sign-in.component';

registerLocaleData(ru);
registerLocaleData(en);

@NgModule({
  declarations: [
    AppComponent,
    AdminSignInComponent,
  ],
  bootstrap: [AppComponent],
  imports: [
    CommonModule,
    CabinetModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    TuiRoot,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production && environment.serviceWorkers,
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    }),
    NbThemeModule.forRoot({name: 'default'}),
    NbLayoutModule,
    AuthModule.forRoot(environment),
    NbEvaIconsModule,
    NbAlertModule,
    NbInputModule,
    NbCardModule,
    NbButtonModule,
    SharedModule.forRoot(environment),
    NbAuthModule.forRoot({}),
    ReactiveFormsModule,
    LoadingBarModule,
    NbDatepickerModule,
    FileUploadModule,
    LoadingBarHttpClientModule,
    LoadingBarRouterModule,
    DamFilesModule,
    DamModule
  ],
  providers: [
    {provide: ErrorHandler, useClass: CompoErrorHandler},
    {provide: LOADING_BAR_CONFIG, useValue: {latencyThreshold: 200}},
    {provide: LOCALE_ID, useValue: environment.locale},
    {provide: TUI_LANGUAGE, useValue: of(environment.tuiLanguage)},
    {provide: 'environment', useValue: environment},
    {provide: environment, useValue: environment},
    {provide: Environment, useValue: environment},
    provideEventPlugins(),
    provideHttpClient(withInterceptorsFromDi()),
  ]
})
export class AppModule {
}
